import * as eventTracker from '../../utils/eventTracker';

const viewedKeys = new Set();

// 측정 실패가 데모 화면을 깨뜨리면 안 된다.
const send = (name, params) => {
  try {
    if (typeof eventTracker.trackEvent === 'function') eventTracker.trackEvent(name, params);
  } catch (e) {
    /* noop */
  }
};

/** 같은 화면에서 같은 데모 노출은 한 번만 보낸다. */
export const trackDemoView = (surface, feature) => {
  const key = `${surface}:${feature}:${window.location?.pathname || ''}`;
  if (viewedKeys.has(key)) return;
  viewedKeys.add(key);
  send('demo_view', { surface, feature });
};

export const trackDemoCta = (surface, feature, destination) => {
  send('demo_cta_click', { surface, feature, destination });
};

export const resetDemoViewTracking = () => viewedKeys.clear();
